// src/components/ItemAlreadyInCartDialog/index.js
import React from 'react';
import { X } from 'lucide-react';
import './index.css';

const ItemAlreadyInCartDialog = ({
  isOpen,
  onClose,
  productName,
  onRepeatSame,
  onCreateNew
}) => {
  if (!isOpen) return null;

  return (
    <div className="item-already-overlay" onClick={onClose}>
      <div className="item-already-modal" onClick={(e) => e.stopPropagation()}>
        <button className="item-already-close" onClick={onClose}>
          <X size={24} />
        </button>

        <div className="item-already-content">
          <h2 className="item-already-title">Item Already in Cart</h2>
          
          <p className="item-already-message">
            You already have <span className="product-name-highlight">{productName}</span> in your cart with customizations. Would you like to:
          </p>

          <div className="item-already-buttons">
            <button 
              className="item-already-btn repeat-same"
              onClick={onRepeatSame}
            >
              <div className="btn-icon">📦</div>
              <div className="btn-content">
                <div className="btn-title">Repeat Same</div>
                <div className="btn-subtitle">Add same customization</div>
              </div>
            </button>

            <button 
              className="item-already-btn create-new"
              onClick={onCreateNew}
            >
              <div className="btn-icon">✏️</div>
              <div className="btn-content">
                <div className="btn-title">Create New</div>
                <div className="btn-subtitle">New customization</div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemAlreadyInCartDialog;
